import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {L10nModule} from '../../translate';
import {TextSearchInputComponent} from './text-search-input.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        FormsModule
    ],
    declarations: [
        TextSearchInputComponent
    ],
    exports: [
        TextSearchInputComponent
    ]
})
export class TextSearchInputModule {}
